import { useMemo } from 'react'

import { RecurringInvoiceStatus } from '@features/recurringInvoices/enums/recurringInvoiceStatus'

import { useFetchRecurringInvoicesSummary } from '../../../hooks/useFetchRecurringInvoicesSummary'

type RecurringInvoicesSummary = {
  [key in RecurringInvoiceStatus]: number
}

const summaryStatusOrder = [
  RecurringInvoiceStatus.All,
  RecurringInvoiceStatus.Draft,
  RecurringInvoiceStatus.Ongoing,
  RecurringInvoiceStatus.Paused,
  RecurringInvoiceStatus.Completed,
]

export const useRecurringInvoicesSummary = () => {
  const { recurringInvoicesSummaryData, isLoading } = useFetchRecurringInvoicesSummary()

  const recurringInvoicesSummary = useMemo(() => {
    return summaryStatusOrder.reduce(
      (summary, status) => {
        summary[status] = recurringInvoicesSummaryData?.[status] || 0

        // "All" is purely on FE level and not a thing in BE data,
        // but making it explicit in this logic as well
        if (status !== RecurringInvoiceStatus.All) {
          summary.all += summary[status]
        }

        return summary
      },
      { all: 0 } as RecurringInvoicesSummary,
    )
  }, [recurringInvoicesSummaryData])

  return {
    isLoading,
    recurringInvoicesSummary,
  }
}
